module.exports = __webpack_public_path__ + "img/logo.ab2aa0f1.png";